<template>
  <div class="page">
    <img v-for="img in imgList" v-lazy="img" :key="img" />
  </div>
</template>

<script>
  import { cdnresources } from '@/util/config'
  export default {
    data() {
      return {
        cdnresources,
        imgList: [
          cdnresources + '/prod/images/xiangaibao/jkfwsc1.png',
          cdnresources + '/prod/images/xiangaibao/jkfwsc2.png',
          cdnresources + '/prod/images/xiangaibao/jkfwsc3.png',
          cdnresources + '/prod/images/xiangaibao/jkfwsc4.png',
          cdnresources + '/prod/images/xiangaibao/jkfwsc5.png',
          cdnresources + '/prod/images/xiangaibao/jkfwsc6.png',
          cdnresources + '/prod/images/xiangaibao/jkfwsc7.png',
          cdnresources + '/prod/images/xiangaibao/jkfwsc8.png',
          cdnresources + '/prod/images/xiangaibao/jkfwsc9.png',
          cdnresources + '/prod/images/xiangaibao/jkfwsc10.png',
          cdnresources + '/prod/images/xiangaibao/jkfwsc11.png'
        ]
      }
    },
    components: {}
  }
</script>

<style lang="scss" scoped>
  img {
    width: 100%;
    height: 100%;
  }
</style>
